/*eslint no-unused-vars: "off"*/
import React from 'react';
import moment from "moment-timezone";
import {isEmpty} from "lodash";
import { formatToCurrency } from '../../../Tools/formatToCurrency';

const SERVICE_TYPE = {
  owned: 'Owned',
  serviced: 'Serviced',
  serviced_not_new: 'Serviced No New',
  residential: 'Residential',
  commercial: 'Commercial'
}

const PRIORITY_MAPPING = {
  1: 'Low',
  2: 'Medium',
  3: 'High'
}

const AUDIT_ASSIGN_MAPPING = {
  new_ticket: 'New Ticket',
}

class DataTable {

    //first List
    AllMessageList = (self) => {
      const messageColumns = [
        {
          title: 'Customer Name',
          dataIndex: 'customer_name',
          key: 'customer_name',
          render: (text, record) => (<span className="type ellipse">{!isEmpty(record?.service?.service_order?.user) ? `${record?.service?.service_order?.user?.first_name} ${record?.service?.service_order?.user?.last_name}` : ''}</span>)
        },
        {
          title: 'Franchise',
          dataIndex: 'field_office',
          key: 'field_office',
          render: (text, record) => (<span className="type ellipse">{text}</span>)
        },
        {
          title: 'Service Type',
          dataIndex: 'service_type',
          key: 'service_type',
          render: (text, record) => (<span className="type ellipse">{!isEmpty(record?.service?.service_order) ? SERVICE_TYPE[record?.service?.service_order?.service_type] : ''}</span>)
        }


      ]
      return messageColumns;
    }

    //second List
    AllTicketList = (self) => {
      const ticketColumns = [
        {
          title: 'Ticket Name',
          dataIndex: 'ticket_name',
          key: 'ticket_name',
          render: (text, record) => (
            <div>
              <span>{text}</span>
              <label>Assigned to Jacob D.</label>
            </div>
          )
        },
        {
          title: 'Customer Name',
          dataIndex: 'customer_name',
          key: 'customer_name',
          render: (text, record) => (<span className="type ellipse">{text}</span>)
        },
        {
          title: 'Priority',
          dataIndex: 'priority',
          key: 'priority',
          render: (text, record) => (
            <span className="type ellipse">
              <span className="status_before low"><i></i>Low</span>
            </span>
          )
        },
        {
          title: 'Ticket Created',
          dataIndex: 'ticket_created',
          key: 'ticket_created',
          render: (text, record) => (
            <span className="type ellipse">
              {text}
            </span>
          )
        }


      ]
      return ticketColumns;
    }
    
    // franchise collection table
    FranchiseCollection = (self) => {
      return ([
        {
          title: 'Zipcode',
          dataIndex: 'zip_codes',
          key: 'zip_codes',
          render: (text) => (<span className="type ellipse">{text?.join(', ')}</span>)
        }, {
          title: 'Type',
          dataIndex: 'u_type',
          key: 'u_type',
          render: (text) => (<span className="type ellipse" title={text}><b>{text ? SERVICE_TYPE[text] : ''}</b></span>)
        }, {
          title: 'Started Service',
          dataIndex: 'started_timestamp',
          key: 'started_timestamp',
          render: (text) => (<span className="type ellipse" title={text}>{text ? moment(text).format('YYYY, MMM') : ''}</span>)
        }, {
          title: 'Active Customers',
          dataIndex: 'active_customners',
          key: 'active_customners',
          render: (text) => (<span className="type ellipse" title={text}>{text}</span>)
        }, {
          title: 'Monthly Rev Average of last 6m',
          dataIndex: 'monthly_revenue_avg_six_months',
          key: 'monthly_revenue_avg_six_months',
          render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
        }, {
          title: 'YTD Revenue',
          dataIndex: 'ytd_revenue',
          key: 'ytd_revenue',
          render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
        }, {
          title: 'All Time Revenue',
          dataIndex: 'all_time_revenue',
          key: 'all_time_revenue',
          render: (text) => (<span className="type ellipse" title={text}>${text ? formatToCurrency(text) : '0'}</span>)
        }, {
          title: 'Satisfaction',
          dataIndex: 'satisfaction',
          key: 'satisfaction',
          render: (text) => (<span className="type ellipse" title={text}>{text ? formatToCurrency(text) : '0'}%</span>)
        }])
    }

  //second List
  FranchiseTicketList = (self) => {
    return [
      {
        title: 'Ticket Name',
        dataIndex: 'title',
        key: 'title',
        render: (text, record) => (
          <div>
            <span>{text}</span>
            <label>{record?.assigned_user_details ? `Assigned to ${record?.assigned_user_details?.first_name}` : ''}</label>
          </div>
        )
      },
      {
        title: 'Priority',
        dataIndex: 'priority',
        key: 'priority',
        render: (text, record) => (
          <span className={`type ellipse`}>
            <span className={`prty ${text === '1' ? 'low' : text === '2' ? 'medium' : text === '3' ? 'high' : ''}`}>{PRIORITY_MAPPING[text]}</span>
          </span>
        )
      },
      {
        title: 'Ticket Created',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (
          <span className="type ellipse">
            {text ? moment(text).format('MMM DD, YYYY') : ''}
          </span>
        )
      }


    ];
  }

  AuditTrailList = (self) => {
    return [
      {
        title: 'Action Performed',
        dataIndex: 'action_performed',
        key: 'action_performed',
        render: (text, record) => (
          <div>
            <span>{AUDIT_ASSIGN_MAPPING[text]}</span>
            <label>{record?.initiated_by ? `by ${record?.initiated_by?.first_name}` : ''}</label>
          </div>
        )
      },
      {
        title: 'Account',
        dataIndex: 'user_details',
        key: 'user_details',
        render: (text, record) => (<span>{text?.first_name ? `${text?.first_name} ${text?.last_name || ''}` : '' }</span>
        )
      },
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (
          <span className="type ellipse">
            {text ? moment(text).format('MMM DD') : ''}
          </span>
        )
      }


    ];
  }

  //second List
  OperationMgrTicketList = (self) => {
    return [
      {
        title: 'Ticket Name',
        dataIndex: 'title',
        key: 'title',
        render: (text, record) => (
          <div>
            <span>{text}</span>
            <label>{record?.assigned_user_details ? `Assigned to ${record?.assigned_user_details?.first_name}` : ''}</label>
          </div>
        )
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer_name',
        key: 'customer_name',
        render: (text, record) => (<span className="type ellipse">{(record?.user_details?.first_name && record?.user_details?.last_name) ? `${record?.user_details?.first_name} ${record?.user_details?.last_name}` : record?.user_details?.first_name}</span>)
      },
      {
        title: 'Priority',
        dataIndex: 'priority',
        key: 'priority',
        render: (text, record) => (
          <span className={`type ellipse`}>
            <span className={`prty ${text === '1' ? 'low' : text === '2' ? 'medium' :  text === '3' ? 'high' : ''}`}>{PRIORITY_MAPPING[text]}</span>
          </span>
        )
      },
      {
        title: 'Ticket Created',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text, record) => (
          <span className="type ellipse">
            {text ? moment(text).format('MMM DD, YYYY') : ''}
          </span>
        )
      }


    ];
  }
}

export default new DataTable();